import { useEffect } from "react";
import api from "@/lib/api";

// Injects Google Search Console verification meta + GA4 (only when a real
// measurement id is configured). Fetches ids from the backend public config
// so nothing sensitive is hardcoded in the bundle.
export default function Analytics() {
  useEffect(() => {
    let cancelled = false;
    api.get("/public/config").then(({ data }) => {
      if (cancelled) return;
      const gsc = data.gsc_verification_token;
      if (gsc && !gsc.includes("placeholder")) {
        let m = document.head.querySelector('meta[name="google-site-verification"]');
        if (!m) { m = document.createElement("meta"); m.setAttribute("name", "google-site-verification"); document.head.appendChild(m); }
        m.setAttribute("content", gsc);
      }
      const ga = data.ga4_measurement_id;
      if (ga && !ga.includes("XXX")) {
        const s = document.createElement("script");
        s.async = true;
        s.src = `https://www.googletagmanager.com/gtag/js?id=${ga}`;
        document.head.appendChild(s);
        window.dataLayer = window.dataLayer || [];
        function gtag() { window.dataLayer.push(arguments); }
        gtag("js", new Date());
        gtag("config", ga);
      }
    }).catch(() => {});
    return () => { cancelled = true; };
  }, []);
  return null;
}
